<dynamic-form
  *ngIf="columns && columns?.length > 0"
  [apiName]="apiName"
  [label]="label"
  [group]="formGroup"
  [areaName]="areaName"
  [model]="model"
  (valueChangeByApiName)="valueChangeByApiName($event)"
  [columns]="columns"
  (cancelChange)="cancel()"
  [noSubmit]="deactivateSave"
  (submitChange)="save()">
  <ng-container class="content">
    <ssg-tabset class="tabcontainer tabcontentbox" (tabChange)="selectTab($event)">
      <ssg-tab [tabTitle]="'ClientApp.GNR.Branch.Setting' | translate">
        <div class="d-flex">
          <div class="col-lg-4">
            <ssg-input
              name="PhoneNumber"
              [group]="formGroup"
              [label]="'ClientApp.GNR.Branch.PhoneNumber' | translate"
              [required]="false"
              disabled="false"
              textType="text">
            </ssg-input>
          </div>
          <div class="col-lg-4">
            <ssg-input
              name="EconomicalNumber"
              [group]="formGroup"
              [label]="'ClientApp.GNR.Branch.EconomicalNumber' | translate"
              required="false"
              disabled="false"
              maxLength="15">
            </ssg-input>
          </div>
          <div class="col-lg-4">
            <ssg-input
              name="NationalCode"
              [group]="formGroup"
              [label]="'ClientApp.GNR.Branch.NationalCode' | translate"
              required="false"
              disabled="false"
              maxLength="12">
            </ssg-input>
          </div>
        </div>
        <div class="col-lg-4">
          <ssg-input
            name="PostalCode"
            [group]="formGroup"
            [label]="'ClientApp.GNR.Branch.PostalCode' | translate"
            required="false"
            disabled="false"
            maxLength="10">
          </ssg-input>
        </div>
        <div>
          <div class="col-lg-4">
            <ssg-tag-input
              name="CustomerTitles"
              [group]="formGroup"
              [label]="'ClientApp.GNR.Branch.CustomerTitles' | translate"
              required="false"
              disabled="false"
              maxLength="256">
            </ssg-tag-input>
          </div>
          <div class="col-lg-4">
            <ssg-checkbox
              id="NoDisplayDashboard"
              name="NoDisplayDashboard"
              [group]="formGroup"
              [label]="'ClientApp.GNR.Branch.NoDisplayDashboard' | translate"
              disabled="false">
            </ssg-checkbox>
          </div>
          <div class="col-lg-4">
            <ssg-checkbox
              id="FullScreenView"
              name="FullScreenView"
              [group]="formGroup"
              [label]="'ClientApp.GNR.Branch.FullScreenView' | translate"
              disabled="false">
            </ssg-checkbox>
          </div>
        </div>
      </ssg-tab>
      <ssg-tab [tabTitle]="'ClientApp.GNR.Branch.SaleSetting' | translate">
        <div class="d-flex">
          <div>
            <div class="content">
              <div class="gap">
                <ssg-input
                  name="TaxPercentage"
                  [group]="formGroup"
                  [label]="'ClientApp.GNR.Branch.TaxPercentage' | translate"
                  required="true"
                  min="0"
                  max="100"
                  type="number"
                  disabled="false"
                  textType="number">
                </ssg-input>
              </div>
              <div class="gap">
                <ssg-input
                  name="TollPercentage"
                  [group]="formGroup"
                  [label]="'ClientApp.GNR.Branch.TollPercentage' | translate"
                  required="true"
                  min="0"
                  max="100"
                  textType="number"
                  disabled="false">
                </ssg-input>
              </div>
              <div class="gap">
                <ssg-input
                  name="ServicePercentage"
                  [group]="formGroup"
                  [label]="'ClientApp.GNR.Branch.ServicePercentage' | translate"
                  required="true"
                  min="0"
                  max="100"
                  textType="number"
                  disabled="false">
                </ssg-input>
              </div>
            </div>
            <div class="content">
              <div class="gap">
                <ssg-input
                  name="StandardDelayTimeForPreparation"
                  [group]="formGroup"
                  [label]="'ClientApp.GNR.Branch.StandardDelayTimeForPreparation' | translate"
                  required="true"
                  min="0"
                  textType="number"
                  disabled="false">
                </ssg-input>
              </div>

              <div class="gap">
                <ssg-input
                  name="AlertDelayTimeForPreparation"
                  [group]="formGroup"
                  [label]="'ClientApp.GNR.Branch.AlertDelayTimeForPreparation' | translate"
                  required="true"
                  min="0"
                  textType="number"
                  disabled="false">
                </ssg-input>
              </div>
              <div class="gap">
                <ssg-input
                  name="TimeForChange"
                  [group]="formGroup"
                  [label]="'ClientApp.GNR.Branch.TimeForChangeDate' | translate"
                  required="true"
                  disabled="false"
                  IsNumberOnly="true">
                </ssg-input>
              </div>
            </div>

            <div>
              <div class="set-tax-round">
                <div class="gap">
                  <ssg-input
                    name="RoundingAmount"
                    [group]="formGroup"
                    [label]="'ClientApp.GNR.Branch.RoundingAmount' | translate"
                    required="true"
                    withComma="true"
                    textType="number"
                    disabled="false">
                  </ssg-input>
                </div>
                <div class="gap">
                  <ssg-input
                    name="TaxPayerToken"
                    [group]="formGroup"
                    [label]="'ClientApp.GNR.Branch.TaxPayerToken' | translate"
                    textType="text"
                    userClass="select-sm"
                    disabled="false">
                  </ssg-input>
                </div>
                <div class="gap">
                  <ssg-input
                    name="PrivateTaxPayerToken"
                    [group]="formGroup"
                    [label]="'ClientApp.GNR.Branch.PrivateKeyTaxpayer' | translate"
                    textType="text"
                    userClass="select-sm"
                    disabled="false">
                  </ssg-input>
                </div>
            
                <div class="gap" *ngIf="currentInformation?.HasProtel">
                  <ssg-input
                    name="ProtelAddress"
                    [group]="formGroup"
                    [label]="'ClientApp.GNR.Branch.ProtelAddress' | translate"
                    textType="text"
                    userClass="select-sm"
                    disabled="false">
                  </ssg-input>
                </div>
              </div>
              
             <div class="set-tax-round">
              <div class="gap">
                <ssg-input
                  name="ServiceId"
                  [group]="formGroup"
                  [label]="'ClientApp.GNR.Branch.ServiceId' | translate"
                  textType="text"
                  userClass="select-sm"
                  disabled="false">
                </ssg-input>
              </div>
              <div class="gap">
                <ssg-input
                  name="PackingPriceId"
                  [group]="formGroup"
                  [label]="'ClientApp.GNR.Branch.PacingPriceId' | translate"
                  textType="text"
                  userClass="select-sm"
                  disabled="false">
                </ssg-input>
              </div>
              <div class="gap">
                <ssg-input
                  name="ShipingCostId"
                  [group]="formGroup"
                  [label]="'ClientApp.GNR.Branch.ShipingCostId' | translate"
                  textType="text"
                  userClass="select-sm"
                  disabled="false">
                </ssg-input>
              </div>
             </div>
              <div class="set-lat">
                <ssg-input
                  class="gap"
                  name="Latitude"
                  [group]="formGroup"
                  [label]="'ClientApp.GNR.Branch.Latitude' | translate"
                  textType="number"
                  disabled="false">
                </ssg-input>
                <ssg-input
                  name="Longitude"
                  [group]="formGroup"
                  [label]="'ClientApp.GNR.Branch.Longitude' | translate"
                  textType="number"
                  disabled="false">
                </ssg-input>
                <div>
                  <i (click)="showMapDialog()" class="icon-map-marker-radius map" [tooltip]="'ClientApp.GNR.Branch.Map' | translate"></i>
                </div>
              </div>

              <div class="gap d-flex" *ngIf="hasLocal">
                <ssg-input
                  name="LocalServiceIp"
                  [group]="formGroup"
                  [label]="'ClientApp.GNR.Branch.ServiceAddress' | translate"
                  maxLength="20"
                  required="true"
                  textType="text"
                  disabled="false"
                  [disabled]="!hasLocal">
                </ssg-input>
                <div class="local-test" (click)="ConnectionTest()">{{ "ClientApp.GNR.Branch.ConnectionLocalServiceTest" | translate }}</div>
              </div>

              <div>
                <ssg-radiobox
                  name="RoundingTypeId"
                  apiName="Lookup"
                  systemName="GNR"
                  category="RoundingType"
                  [group]="formGroup"
                  [label]="'ClientApp.GNR.Branch.RoundingTypeId' | translate"
                  textFieldName="Title"
                  valueFieldName="Id">
                </ssg-radiobox>
              </div>
              <div>
                <ssg-radiobox
                  name="ShippingCostReducedKindId"
                  apiName="Lookup"
                  systemName="GNR"
                  category="ShippingCostReducedKind"
                  [group]="formGroup"
                  [label]="'ClientApp.GNR.Branch.ShippingCostReducedKindId' | translate"
                  textFieldName="Title"
                  valueFieldName="Id">
                </ssg-radiobox>
              </div>
            </div>
          </div>
          <div class="invcheck">
            <div>
              <ssg-checkbox
                id="AddSettlementForUnpaidAndSuspendedInvoices"
                name="AddSettlementForUnpaidAndSuspendedInvoices"
                [group]="formGroup"
                [label]="'ClientApp.GNR.Branch.AddSettlementForUnpaidAndSuspendedInvoices' | translate"
                disabled="false">
              </ssg-checkbox>
            </div>
            <div>
              <ssg-checkbox
                id="HasDecimal"
                name="HasDecimal"
                [group]="formGroup"
                [label]="'ClientApp.GNR.Branch.GiveTheNumberAsDecimal' | translate"
                disabled="false">
              </ssg-checkbox>
            </div>
            <div>
              <ssg-checkbox
                id="HasLocalService"
                name="HasLocalService"
                [group]="formGroup"
                [label]="'ClientApp.GNR.Branch.HasLocalService' | translate"
                disabled="false"
                (valueChange)="showLocal($event)">
              </ssg-checkbox>
            </div>
            <div>
              <ssg-checkbox
                id="HasAuditorInSalesAmounts"
                name="HasAuditorInSalesAmounts"
                [group]="formGroup"
                [label]="'ClientApp.GNR.Branch.HasAuditorInSalesAmounts' | translate"
                disabled="false">
              </ssg-checkbox>
            </div>
            <div>
              <ssg-checkbox
                id="HasTotalDebit"
                name="HasTotalDebit"
                [group]="formGroup"
                [label]="'ClientApp.GNR.Branch.HasTotalDebit' | translate"
                disabled="false">
              </ssg-checkbox>
            </div>
            <div>
              <ssg-checkbox
                id="HasDirectlyTaxpayer"
                name="HasDirectlyTaxpayer"
                [group]="formGroup"
                [label]="'ClientApp.GNR.Branch.HasDirectlyTaxpayer' | translate"
                disabled="false">
              </ssg-checkbox>
            </div>
            <div *ngIf="isAccessToAllBranches">
              <ssg-checkbox
                id="SendVoucherFromCenter"
                name="SendVoucherFromCenter"
                [group]="formGroup"
                [label]="'ClientApp.GNR.Branch.SendVoucherFromCenter' | translate"
                disabled="false">
              </ssg-checkbox>
            </div>
          </div>
        </div>
      </ssg-tab>
      <ssg-tab [tabTitle]="'ClientApp.GNR.Branch.PrintSetting' | translate">
        <div>
          <div class="message">
            <ssg-textarea
              name="Message"
              [group]="formGroup"
              [label]="'ClientApp.GNR.Branch.PrintEndPage' | translate"
              required="false"
              disabled="false"
              maxLength="256">
            </ssg-textarea>
          </div>
          <div class="d-flex">
            <div class="col-lg-4">
              <div *ngIf="isSepidzUser">
                <ssg-checkbox
                  id="DisplayLogoInPrintTemplates"
                  name="DisplayLogoInPrintTemplates"
                  [group]="formGroup"
                  [label]="'ClientApp.GNR.Branch.DisplayLogoInPrintTemplates' | translate"
                  disabled="false">
                </ssg-checkbox>
              </div>
              <div>
                <ssg-checkbox
                  id="DisplayAddressInInvoice"
                  name="DisplayAddressInInvoice"
                  [group]="formGroup"
                  [label]="'ClientApp.GNR.Branch.DisplayAddressInInvoice' | translate"
                  disabled="false">
                </ssg-checkbox>
              </div>
              <div>
                <ssg-checkbox
                  id="IgnoreBlackBackground"
                  name="IgnoreBlackBackground"
                  [group]="formGroup"
                  [label]="'ClientApp.GNR.Branch.IgnoreBlackBackground' | translate"
                  disabled="false">
                </ssg-checkbox>
              </div>
            </div>
            <div>
              <ssg-radiobox
                name="CurrencyId"
                apiName="Lookup"
                systemName="GNR"
                category="Currency"
                [group]="formGroup"
                [label]="'ClientApp.GNR.Branch.CurrencyId' | translate"
                textFieldName="Title"
                valueFieldName="Id">
              </ssg-radiobox>
            </div>
          </div>
        </div>
      </ssg-tab>
      <ssg-tab *ngIf="isSepidzUser" [tabTitle]="'ClientApp.GNR.Branch.SmsSetting' | translate">
        <div class="setsms">
          <div class="col-lg-3">
            <div class="gap">
              <ssg-input
                [isReadOnly]="true"
                name="SmsAdvertisingNumber"
                [group]="formGroup"
                [label]="'ClientApp.GNR.Branch.SmsAdvertisingNumber' | translate"
                required="false"
                disabled="false"
                maxLength="15">
              </ssg-input>
            </div>
            <div class="gap">
              <ssg-input
                [isReadOnly]="true"
                name="SmsServiceNumber"
                [group]="formGroup"
                [label]="'ClientApp.GNR.Branch.SmsServiceNumber' | translate"
                required="false"
                disabled="false"
                maxLength="15">
              </ssg-input>
            </div>
          </div>
        </div>
        <div>
          <div>
            <ssg-checkbox
              id="chbEnableCreateCustomerSms"
              name="EnableCreateCustomerSms"
              [group]="formGroup"
              [label]="'ClientApp.GNR.Branch.EnableCreateCustomerSms' | translate"
              disabled="false">
            </ssg-checkbox>
          </div>
          <div>
            <ssg-checkbox
              id="chbEnableAssignToDriverSms"
              name="EnableAssignToDriverSms"
              [group]="formGroup"
              [label]="'ClientApp.GNR.Branch.EnableAssignToDriverSms' | translate"
              disabled="false">
            </ssg-checkbox>
          </div>
        </div>
      </ssg-tab>
      <ssg-tab *ngIf="isSepidzUser" [tabTitle]="'ClientApp.GNR.Branch.BranchDataTransferInfo' | translate">
        <kgrid
          *ngIf="model.BranchDataTransferInfos != undefined && isActveTab('ClientApp.GNR.Branch.BranchDataTransferInfo' | translate)"
          [apiName]="apiName"
          [areaName]="areaName"
          [noToolBar]="true"
          [editFromForm]="true"
          [name]="apiName"
          [isAdd]="true"
          [filtering]="false"
          [isEdit]="true"
          [hasColumnMenu]="false"
          [groupable]="false"
          [columns]="BranchDataTransferInfos"
          (onCreate)="onCreate()"
          (onEdit)="onEdit($event)"
          (onDelete)="onDelete($event)"
          [dataList]="model.BranchDataTransferInfos"
          reportName="BranchDataTransferInfo"
          pathPreFix="GNR"
          [inputEditorform]="inputEditorform">
        </kgrid>
      </ssg-tab>
      <ssg-tab [tabTitle]="'ClientApp.GNR.Branch.InternetSettings' | translate" *ngIf="hasOrderOnline">
        <ssg-checkbox
          id="HasOrderOnline"
          name="HasOrderOnline"
          [group]="formGroup"
          [label]="'ClientApp.GNR.Branch.HasOrderOnline' | translate"
          disabled="false"
          (valueChange)="onHasOrderOnline($event)">
        </ssg-checkbox>
        <ssg-checkbox
          id="ReadyToReceiveOnlineOrders"
          name="ReadyToReceiveOnlineOrders"
          [group]="formGroup"
          [label]="'ClientApp.GNR.Branch.ReadyToReceiveOnlineOrders' | translate"
          disabled="false">
        </ssg-checkbox>
        <ssg-checkbox
          id="AutoPrintOnline"
          name="AutoPrintOnline"
          [group]="formGroup"
          [label]="'ClientApp.GNR.Branch.AutoPrintOnline' | translate"
          disabled="false">
        </ssg-checkbox>
        <ssg-checkbox
          id="CustomerPrintOrderOnile"
          name="CustomerPrintOrderOnile"
          [group]="formGroup"
          [label]="'ClientApp.GNR.Branch.CustomerPrintOrderOnile' | translate"
          disabled="false">
        </ssg-checkbox>
        <ssg-checkbox
          id="AutoPrintCash"
          name="AutoPrintCash"
          [group]="formGroup"
          [label]="'ClientApp.GNR.Branch.AutoPrintCash' | translate"
          disabled="false">
        </ssg-checkbox>
        <ssg-select
          [dataList]="PaymentTypeData"
          [required]="true"
          id="PaymentType"
          name="PaymentType"
          [group]="formGroup"
          [label]="'ClientApp.GNR.Branch.PaymentType' | translate"
          textFieldName="Title"
          valueFieldName="Id"
          userClass="select-sm">
        </ssg-select>
      </ssg-tab>
      <ssg-tab
        [tabTitle]="'ClientApp.GNR.Branch.AccountingSetting' | translate"
        *ngIf="
          currentInformation.AccountingKind === SoftWareLicenseKind.AccountingAdvancedWeb ||
          currentInformation.AccountingKind === SoftWareLicenseKind.AccountingToAdvancedWeb ||
          currentInformation.AccountingKind === SoftWareLicenseKind.AccountingWeb
        ">
        <div class="d-flex">
          <div class="col-lg-3">
            <ssg-checkbox
              id="HasAccounting"
              name="HasAccounting"
              (valueChange)="checkAccounting($event)"
              [group]="formGroup"
              [label]="'ClientApp.GNR.Branch.HasAccounting' | translate">
            </ssg-checkbox>
          </div>
          <div class="col-lg-3">
            <ssg-checkbox
              id="ApplyServicesForFee"
              name="ApplyServicesForFee"
              [group]="formGroup"
              [label]="'ClientApp.GNR.Branch.ApplyServicesForFee' | translate">
            </ssg-checkbox>
          </div>
        </div>
        <ng-container *ngIf="hasAccounting">
          <div class="d-flex">
            <div class="col-lg-3">
              <ssg-checkbox
                id="AccVoucherSeparatedByDay"
                name="AccVoucherSeparatedByDay"
                [group]="formGroup"
                [label]="'ClientApp.GNR.Branch.AccVoucherSeparatedByDay' | translate">
              </ssg-checkbox>
            </div>
            <div class="col-lg-4">
              <ssg-select
                name="DetailLedgerId"
                [group]="formGroup"
                [label]="'ClientApp.GNR.Branch.DetailLedgerId' | translate"
                apiName="DetailLedger/GetPagining"
                valueFieldName="Id"
                textColumnsName="Title,Code"
                filterKey="Title,Code"
                [columnsTitleName]="'ClientApp.GNR.Branch.Code' | translate"
                [isMultiColumns]="true"
                textFieldName="Title"
                SortColumn="Code"
                IsEqual="true">
              </ssg-select>
            </div>
          </div>
          <div class="d-flex">
            <div class="col-lg-3 radio-margin-bottom">
              <ssg-radiobox
                [label]="'ClientApp.GNR.Branch.TransferDebtorsTypeId' | translate"
                name="TransferDebtorsTypeId"
                apiName="Lookup"
                systemName="ACC"
                (valueChange)="TransferDebtorsTypeChange($event)"
                [group]="formGroup"
                category="AggregateAndSeparate"
                textFieldName="Title"
                valueFieldName="Id"
                (CompleteData)="onAggregateAndSeparateLoad($event)">
              </ssg-radiobox>
            </div>
            <div class="col-lg-4" *ngIf="TransferDebtorsType">
              <ssg-select
                name="DebtorsSubLedgerId"
                [group]="formGroup"
                [label]="'ClientApp.GNR.Branch.DebtorsSubLedgerId' | translate"
                apiName="DetailLedger/GetPagining"
                valueFieldName="Id"
                textColumnsName="Title,Code"
                filterKey="Title,Code"
                [columnsTitleName]="'ClientApp.GNR.Branch.Code' | translate"
                [isMultiColumns]="true"
                textFieldName="Title"
                SortColumn="Code"
                IsEqual="true">
              </ssg-select>
            </div>
          </div>
          <div class="d-flex">
            <div class="col-lg-3 radio-margin-bottom">
              <ssg-radiobox
                [label]="'ClientApp.GNR.Branch.SendingSalesTypeId' | translate"
                name="SendingSalesTypeId"
                apiName="Lookup"
                systemName="ACC"
                (valueChange)="SendingSalesTypeChange($event)"
                [group]="formGroup"
                category="AggregateAndSeparate"
                textFieldName="Title"
                valueFieldName="Id">
              </ssg-radiobox>
            </div>
            <div class="col-lg-4" *ngIf="SendingSalesType">
              <ssg-select
                name="SendingSalesTitle"
                [dataList]="SendingSalesTypes"
                textFieldName="Title"
                valueFieldName="Id"
                [multiple]="true"
                [group]="formGroup"
                [label]="'ClientApp.GNR.Branch.Title' | translate"
                disabled="false"
                [multiple]="true"></ssg-select>
            </div>
          </div>
          <!-- <div class="d-flex">
            <div class="col-lg-3">
              <ssg-radiobox
                [label]="'ClientApp.GNR.Branch.SendingCashierTypeId' | translate"
                name="SendingCashierTypeId"
                apiName="Lookup"
                systemName="ACC"
                [group]="formGroup"
                category="AggregateAndSeparate"
                textFieldName="Title"
                valueFieldName="Id">
              </ssg-radiobox>
            </div>
          </div> -->
        </ng-container>
      </ssg-tab>
      <ssg-tab
        [tabTitle]="'ClientApp.GNR.Branch.InvSetting' | translate"
        *ngIf="currentInformation.SepidzWebKind !== SoftWareLicenseKind.RestaurantLightWeb">
        <div class="d-flex flex-column">
          <div class="col-lg-3">
            <ssg-select
              name="InvDailyBalanceInhibitorId"
              [dataList]="InvDailyBalanceInhibitorEnumDataList"
              textFieldName="Title"
              valueFieldName="Id"
              [group]="formGroup"
              [label]="'ClientApp.GNR.Branch.InvDailyBalanceInhibitor' | translate"
              disabled="false">
            </ssg-select>
          </div>
          <div class="col-lg-3" *ngIf="currentInformation.SaleInventory">
            <ssg-select
              name="InvWarehouseId"
              [label]="'ClientApp.GNR.Branch.warehouse' | translate"
              apiName="Warehouse"
              valueFieldName="Id"
              [group]="formGroup"
              textFieldName="Title"
              disabled="false" />
          </div>
        </div>
      </ssg-tab>
      <ssg-tab [tabTitle]="'ClientApp.GNR.Branch.CourierFleet' | translate" *ngIf="!!currentInformation.SafirToken">
        <div class="courier-fleet-box">
          <div>
            <ssg-checkbox
              id="HasFleetService"
              name="HasFleetService"
              [group]="formGroup"
              [label]="'ClientApp.GNR.Branch.EnableAmbassadorService' | translate"
              disabled="false"
              (valueChange)="showFleetService($event)">
            </ssg-checkbox>
          </div>
          <div class="latlong-inputs">
            <ssg-input
              class="gap"
              name="Latitude"
              [group]="formGroup"
              [label]="'ClientApp.GNR.Branch.Latitude' | translate"
              textType="number"
              disabled="false"
              userClass="select-sm"
              [disabled]="!hasFleetService">
            </ssg-input>
            <ssg-input
              name="Longitude"
              [group]="formGroup"
              [label]="'ClientApp.GNR.Branch.Longitude' | translate"
              textType="number"
              disabled="false"
              userClass="select-sm"
              [disabled]="!hasFleetService">
            </ssg-input>
            <div>
              <i (click)="showMapDialog()" class="icon-map-marker-radius map" [tooltip]="'ClientApp.GNR.Branch.Map' | translate"></i>
            </div>
          </div>
          <div class="courier-time">
            <ssg-input
              class="courier-time_right"
              name="MaxStopTime"
              [group]="formGroup"
              [label]="'ClientApp.GNR.Branch.MaxStopTime' | translate"
              textType="number"
              disabled="false"
              userClass="select-sm"
              [disabled]="!hasFleetService">
            </ssg-input>
            <ssg-input
              name="MaxConfirmTime"
              [group]="formGroup"
              [label]="'ClientApp.GNR.Branch.MaxConfirmTime' | translate"
              textType="number"
              disabled="false"
              userClass="select-sm"
              [disabled]="!hasFleetService">
            </ssg-input>
          </div>
          <div class="d-flex">
            <div>
              <ssg-checkbox
                id="MergePickupState"
                name="MergePickupState"
                [group]="formGroup"
                [label]="'ClientApp.GNR.Branch.ConfirmationOrderDeliverySmeTimeTripStarts' | translate"
                disabled="false">
              </ssg-checkbox>
            </div>
            <div class="mr-4">
              <ssg-checkbox
                id="MergeDeliveryState"
                name="MergeDeliveryState"
                [group]="formGroup"
                [label]="'ClientApp.GNR.Branch.EndJourneyTimeDeliveryOrder' | translate"
                disabled="false">
              </ssg-checkbox>
            </div>
          </div>
          <div>
            <div>
              <ssg-checkbox
                id="multiOrder"
                name="multiOrder"
                [group]="formGroup"
                [label]="'ClientApp.GNR.Branch.ReceiveMultipleRoutesSameTime' | translate"
                disabled="false">
              </ssg-checkbox>
            </div>
          </div>
        </div>
      </ssg-tab>
    </ssg-tabset>
  </ng-container>
</dynamic-form>
